<template>
  <div class="program-block">
    <p class="program-block__name is-unselectable">{{ name }}</p>
    <program-item
      v-for="(item, index) in items"
      :key="index"
      :title="item.title"
      :from="item.beginTime"
      :to="item.endTime"
      :current="current"
      :now="now"
    />
  </div> </template
>block

<script>
import dayjs from "dayjs";

import ProgramItem from "./ProgramItem";

export default {
  name: "program-block",

  components: {
    ProgramItem
  },

  props: {
    name: String,
    items: Array,
    current: dayjs,
    now: dayjs
  }
};
</script>

<style lang="scss" scoped>
.program-block {
  &:not(:first-child) {
    margin-top: 3rem;
  }

  &__name {
    font-family: $family-sans-serif-condensed;
    font-weight: 700;
  }
}
</style>
